import Cookies from "js-cookie";
export const statusShowMock = [
  { label: "عدم نمایش", value: "1" },
  { label: "نمایش", value: "2" },
];

export const statusMock = [
  { text: "عدم نمایش", value: 1 },
  { text: "نمایش", value: 2 },
];

export const transportationType = [
  { label: "اتوبوس", value: "1" },
  { label: "مترو", value: "2" },
];

export const repeatMock = [
  { label: "پرتکرار است", value: "true" },
  { label: "پر تکرار نیست", value: "false" },
];

export const langMock = [
  { label: "فارسی", value: "1" },
  { label: "انگلیسی", value: "2" },
];

export const tokenMock = `Bearer ${Cookies.get("token")}`;

/**
   * 

1 -> phone number

2 -> email

3 -> address

4 -> fax

5 -> postal code

6 -> working hours
   */
export const contactMock = [
  {
    label: "شماره تماس",
    value: "1",
  },
  {
    label: "ایمیل",
    value: "2",
  },
  {
    label: "آدرس",
    value: "3",
  },
  {
    label: "فکس",
    value: "4",
  },
  {
    label: "کد پستی",
    value: "5",
  },
  {
    label: "ساعت کاری",
    value: "6",
  },
];

/**
 *  int | 1 -> virtual | 2 -> online | 3 -> in-person
 */
export const typeMock = [
  {
    label: "مجازی",
    value: 1,
  },
  {
    label: "آنلاین",
    value: 2,
  },
  {
    label: "حضوری",
    value: 3,
  },
];

export const language_choices = [
  {
    value: 1,
    label: "فارسی",
  },
  {
    value: 2,
    label: "انگلیسی",
  },
  {
    value: 3,
    label: "اسپانیایی",
  },
  {
    value: 4,
    label: "فرانسوی",
  },
  {
    value: 5,
    label: "آلمانی",
  },
  {
    value: 6,
    label: "عربی",
  },
  {
    value: 7,
    label: "روسی",
  },
  {
    value: 8,
    label: "چینی",
  },
  {
    value: 9,
    label: "ژاپنی",
  },
  {
    value: 10,
    label: "کره ای",
  },
];
